import { useAppSelector } from '../slices/index';
import * as Cases from '../slices/casesSlice';
import { getUkDate } from '../utilities';

const ReportSite = () => {
	const cases = useAppSelector(state => state.cases);

	return (
		<table style={{ borderSpacing: 0, borderCollapse: 'collapse' }}>
			{(cases.report.sites || []).map((s: Cases.reportSiteState) => {
				return (
					<thead>
						<tr>
							<th className='TabHeaderLeft' style={{ padding: '12px 8px' }}>{s.SchemeDescription}</th>
							<th className='TabHeaderRight' style={{ padding: '12px 8px' }} colSpan={17}>{s.SchemeDescription}</th>
						</tr>
						<tr>
							<th>Property/Client Name/PLS Reference</th>
							<th>Reservation Date</th>
							<th>Help 2 Buy?</th>
							<th>ATP Received</th>
							<th>Date CCL Sent</th>
							<th>CCL Signed</th>
							<th>Contract Received</th>
							<th>Payment for Searches Received Date</th>
							<th>Searches Applied For</th>
							<th>Searches Expected to Return</th>
							<th>Searches Received</th>
							<th>Reported to Client</th>
							<th>Mortgage Offer In</th>
							<th>Cash Purchase?</th>
							<th>Related PX Position?</th>
							<th>Form 1 Sent</th>
							<th>Exchange Date</th>
							<th>Outstanding Issues</th>
						</tr>

						{(s.cases || []).map((c: Cases.reportCaseState) => {
							return (
								<tr style={{ padding: '8px 0', borderBottom: '1px solid #F4941E' }}>
									<td>{c.casekey}</td>
									<td>{getUkDate(c.ReservationDate)}</td>
									<td>{c.GovScheme}</td>
									<td>{getUkDate(c.ATPReceivedDatePurchase)}</td>
									<td>{getUkDate(c.ClientComplaintInfoSentOnDatePurchase)}</td>
									<td>{getUkDate(c.ClientComplaintInfoReturnedOnDatePurchase)}</td>
									<td>{getUkDate(c.ContractsReceivedDatePurchase)}</td>
									<td>{getUkDate(c.PaymentForAdvanceCostsAndSearchesReceivedDate)}</td>
									<td>{getUkDate(c.SearchesOrderedDatePurchase)}</td>
									<td>{getUkDate(c.SearchesExpectedReturnedDatePurchase)}</td>
									<td>{getUkDate(c.SearchesReceivedDatePurchase)}</td>
									<td>{getUkDate(c.ReportedToClientDatePurchase)}</td>
									<td>{getUkDate(c.SignedMortgageReceivedDate)}</td>
									<td>{c.CashPurchase}</td>
									<td>{c.PartExNotes}</td>
									<td>{getUkDate(c.HelpToBuyForm1SentDate)}</td>
									<td>{getUkDate(c.ExchangeDatePurchase)}</td>
									<td>{c.OutstandingIssues}</td>
								</tr>
							)
						})}
					</thead>
				)
			})}
		</table>
	);
}

export default ReportSite;